import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Footer from '../componente/Footer';
import locatiiData from '../date/locatii.json';
import { FaCar, FaHome, FaBriefcase, FaLaptop, FaTshirt, FaWrench, FaCouch, FaBabyCarriage, FaBicycle, FaPaw, FaTools } from 'react-icons/fa';

function Acasa() {
  const [anunturi, setAnunturi] = useState([]);
  const [incarca, setIncarca] = useState(true);
  const [textCautat, setTextCautat] = useState('');
  const [categorieExtinsa, setCategorieExtinsa] = useState(null);
  const [listaFavorite, setListaFavorite] = useState([]);
  const [judetSelectat, setJudetSelectat] = useState('');
  const [localitateSelectata, setLocalitateSelectata] = useState('');
  const navigate = useNavigate();

  const categorii = [
    {
      nume: 'Auto, moto si ambarcatiuni',
      culoare: 'bg-red-50 text-red-600 group-hover:bg-red-600 group-hover:text-white',
      icon: <FaCar className="w-8 h-8" />,
      subcategorii: ["Autoturisme", "Autoutilitare", "Camioane - Rulote - Remorci", "Motociclete", "Scutere - ATV - UTV", "Ambarcatiuni", "Utilaje agricole si industriale"]
    },
    {
      nume: 'Imobiliare',
      culoare: 'bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white',
      icon: <FaHome className="w-8 h-8" />,
      subcategorii: ["Apartamente - Garsoniere de vanzare", "Apartamente - Garsoniere de inchiriat", "Case de vanzare", "Case de inchiriat", "Terenuri", "Spatii comerciale", "Birouri - Spatii industriale", "Cazare - Turism"]
    },
    {
      nume: 'Locuri de munca',
      culoare: 'bg-emerald-50 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white',
      icon: <FaBriefcase className="w-8 h-8" />,
      subcategorii: ["IT - Telecomunicatii", "Inginerie - Arhitectura", "Vanzari", "Administrativ - Secretariat", "Finante - Contabilitate", "Transport - Logistica", "Constructii - Meseriasi", "Horeca", "Personal medical"]
    },
    {
      nume: 'Electronice si electrocasnice',
      culoare: 'bg-purple-50 text-purple-600 group-hover:bg-purple-600 group-hover:text-white',
      icon: <FaLaptop className="w-8 h-8" />,
      subcategorii: ["Telefoane", "Electrocasnice", "Tablete - eReadere", "TV", "Videoproiectoare & Accesorii", "Retelistica & Servere", "Piese telefoane & tablete", "Laptop-Calculator-Gaming", "Ingrijire Personala", "Periferice & Accesorii Laptop-PC-Gaming", "Imprimante, scannere", "Home Cinema & Audio", "Gadgets, Wearables & Camere foto-video", "Drone & accesorii", "Componente Laptop-PC", "Casti Audio", "Casa inteligenta - Smarthome", "Audio Hi Fi & Profesionale", "Aparate medicale & Wellness", "Accesorii telefoane & tablete"]
    },
    {
      nume: 'Moda si frumusete',
      culoare: 'bg-pink-50 text-pink-600 group-hover:bg-pink-600 group-hover:text-white',
      icon: <FaTshirt className="w-8 h-8" />,
      subcategorii: ["Incaltaminte barbati", "Haine barbati", "Incaltaminte dama", "Haine dama", "Bijuterii - Accesorii", "Cosmetice - Parfumuri", "Rochii de mireasa"]
    },
    {
      nume: 'Piese auto',
      culoare: 'bg-slate-50 text-slate-600 group-hover:bg-slate-600 group-hover:text-white',
      icon: <FaWrench className="w-8 h-8" />,
      subcategorii: ["Piese auto", "Roti - Jante - Anvelope", "Consumabile - Accesorii", "Sisteme Audio - Navigatie", "Echipamente si accesorii moto"]
    },
    {
      nume: 'Casa si gradina',
      culoare: 'bg-amber-50 text-amber-600 group-hover:bg-amber-600 group-hover:text-white',
      icon: <FaCouch className="w-8 h-8" />,
      subcategorii: ["Mobila - Decoratiuni", "Materiale constructii si amenajari", "Unelte - Scule - Feronerie", "Termice - Electrice - Sanitare", "Gradina", "Articole menaj"]
    },
    {
      nume: 'Mama si copilul',
      culoare: 'bg-teal-50 text-teal-600 group-hover:bg-teal-600 group-hover:text-white',
      icon: <FaBabyCarriage className="w-8 h-8" />,
      subcategorii: ["Haine - Incaltaminte copii", "Carucioare - Landouri", "Camera copilului", "Jucarii", "Alimentatie - Ingrijire", "Articole scolare"]
    },
    {
      nume: 'Sport, timp liber, arta',
      culoare: 'bg-cyan-50 text-cyan-600 group-hover:bg-cyan-600 group-hover:text-white',
      icon: <FaBicycle className="w-8 h-8" />,
      subcategorii: ["Biciclete - Fitness - Suplimente", "Echipamente sportive", "Turism - Echipamente", "Arta - Obiecte de colectie", "Instrumente muzicale", "Carti - Muzica - Filme"]
    },
    {
      nume: 'Animale de companie',
      culoare: 'bg-orange-50 text-orange-600 group-hover:bg-orange-600 group-hover:text-white',
      icon: <FaPaw className="w-8 h-8" />,
      subcategorii: ["Caini", "Pisici", "Animale de ferma", "Pasari", "Pesti", "Alte animale", "Accesorii si hrana"]
    },
    {
      nume: 'Servicii',
      culoare: 'bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white',
      icon: <FaTools className="w-8 h-8" />,
      subcategorii: ["Auto - Transport", "Meseriasi - Constructori", "Reparatii IT - Electronice", "Evenimente - Divertisment", "Cursuri - Meditatii", "Servicii de curatenie", "Servicii de infrumusetare"]
    }
  ];

  useEffect(function() {
    incarcaAnunturi();
    const token = localStorage.getItem('token');
    if (token) {
      incarcaFavoriteleUtilizatorului(token);
    }
  }, []);

  function incarcaAnunturi() {
    setIncarca(true);
    fetch('https://tranzitio.onrender.com/api/anunturi/toate')
      .then(function(res) {
        return res.json();
      })
      .then(function(data) {
        setAnunturi(data);
        setIncarca(false);
      })
      .catch(function(err) {
        console.error(err);
        setIncarca(false);
      });
  }

  async function incarcaFavoriteleUtilizatorului(token) {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/favorite/mele', {
        headers: { 'x-auth-token': token }
      });
      if (raspuns.ok) {
        const date = await raspuns.json();
        const idUriFavorite = [];
        for (let i = 0; i < date.length; i++) {
          if (date[i].anunt) {
            idUriFavorite.push(date[i].anunt._id);
          }
        }
        setListaFavorite(idUriFavorite);
      }
    } catch (err) {
      console.log(err);
    }
  }

  function pornesteCautarea(cat, subcat) {
  const params = new URLSearchParams();

  if (subcat) {
    params.set('cat', cat);
    params.set('subcat', subcat);
  } else if (cat) {
    params.set('cat', cat);
  } else if (textCautat.trim()) {
    params.set('q', textCautat);
  }

  if (judetSelectat) {
    params.set('judet', judetSelectat);
  }
  if (localitateSelectata) {
    params.set('localitate', localitateSelectata);
  }

  navigate('/cautare?' + params.toString());
}

  function gestioneazaClickCategorie(numeCat) {
    if (categorieExtinsa === numeCat) {
      setCategorieExtinsa(null);
    } else {
      setCategorieExtinsa(numeCat);
    }
  }

  async function toggleFavorit(e, idAnunt) {
    e.preventDefault();
    e.stopPropagation();
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Trebuie sa fii logat pentru a salva favorite!');
      return;
    }
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/favorite/' + idAnunt, {
        method: 'POST',
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      if (date.adaugat) {
        const listaNoua = [...listaFavorite, idAnunt];
        setListaFavorite(listaNoua);
        toast.success(date.mesaj);
      } else {
        const listaFiltrata = listaFavorite.filter(function(id) {
          return id !== idAnunt;
        });
        setListaFavorite(listaFiltrata);
        toast.success('Anuntul a fost sters din favorite.');
      }
    } catch (err) {
      toast.error('Eroare la procesarea favoritelor.');
    }
  }

  const skeletonItems = [0, 1, 2, 3, 4, 5, 6, 7];

  let categorieGasita = null;
  if (categorieExtinsa) {
    for (let i = 0; i < categorii.length; i++) {
      if (categorii[i].nume === categorieExtinsa) {
        categorieGasita = categorii[i];
        break;
      }
    }
  }

  return (
    <div className="min-h-screen bg-[#f3f4f6] font-sans text-gray-900">

      <div className="bg-gradient-to-r from-blue-700 via-blue-800 to-indigo-900 py-24 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
        <div className="max-w-5xl mx-auto px-4 relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight drop-shadow-md">
            Descopera ce e in jurul tau.
          </h1>
          <p className="text-blue-100 mb-12 text-xl font-medium max-w-2xl mx-auto">
            De la masini la case, gasesti absolut tot ce cauti pe cea mai sigura platforma din Romania.
          </p>
          <div className="bg-white p-3 rounded-2xl shadow-2xl flex flex-col gap-3 max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row gap-3">
              <div className="flex-grow flex items-center px-4 bg-gray-50 rounded-xl border border-gray-100 focus-within:ring-2 focus-within:ring-blue-100 transition-all">
                <svg className="w-6 h-6 text-gray-400 mr-3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder="Ce iti doresti astazi?"
                  className="w-full py-4 bg-transparent text-gray-800 focus:outline-none text-lg font-medium"
                  value={textCautat}
                  onChange={function(e) { setTextCautat(e.target.value); }}
                  onKeyPress={function(e) {
                    if (e.key === 'Enter') {
                      pornesteCautarea();
                    }
                  }}
                />
              </div>
              <button
                onClick={function() { pornesteCautarea(); }}
                className="bg-rose-500 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-rose-600 shadow-md transition-all whitespace-nowrap"
              >
                Cauta anunturi
              </button>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 px-1">
              <select
                value={judetSelectat}
                onChange={function(e) {
                  setJudetSelectat(e.target.value);
                  setLocalitateSelectata('');
                }}
                className="flex-1 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm font-medium text-gray-700 focus:outline-none focus:border-blue-400 transition-colors"
              >
                <option value="">Toate judetele</option>
                {Object.keys(locatiiData).sort().map(function(j) {
                  return <option key={j} value={j}>{j}</option>;
                })}
              </select>
              {judetSelectat && (
                <select
                  value={localitateSelectata}
                  onChange={function(e) { setLocalitateSelectata(e.target.value); }}
                  className="flex-1 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm font-medium text-gray-700 focus:outline-none focus:border-blue-400 transition-colors"
                >
                  <option value="">Toate localitatile</option>
                  {(locatiiData[judetSelectat] || []).map(function(l) {
                    return <option key={l} value={l}>{l}</option>;
                  })}
                </select>
              )}
            </div>
          </div>
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-4 -mt-10 relative z-20">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <h2 className="text-xl font-bold text-gray-800 mb-8 text-center">Descopera categoriile principale</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {categorii.map(function(cat) {
              let clasaBorder = 'group flex flex-col items-center gap-3 p-4 rounded-2xl transition-all border-2 border-transparent hover:bg-gray-50';
              if (categorieExtinsa === cat.nume) {
                clasaBorder = 'group flex flex-col items-center gap-3 p-4 rounded-2xl transition-all border-2 border-blue-500 bg-blue-50';
              }
              let clasaText = 'text-sm font-bold text-center text-gray-700 group-hover:text-gray-900';
              if (categorieExtinsa === cat.nume) {
                clasaText = 'text-sm font-bold text-center text-blue-700';
              }
              let clasaIcon = 'w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-300 ' + cat.culoare;
              if (categorieExtinsa === cat.nume) {
                clasaIcon = clasaIcon + ' shadow-md scale-105';
              }
              return (
                <button
                  key={cat.nume}
                  onClick={function() { gestioneazaClickCategorie(cat.nume); }}
                  className={clasaBorder}
                >
                  <div className={clasaIcon}>
                    {cat.icon}
                  </div>
                  <span className={clasaText}>{cat.nume}</span>
                </button>
              );
            })}
          </div>

          {categorieGasita && (
            <div className="mt-8 bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8 shadow-inner">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 border-b border-gray-200 pb-4">
                <h3 className="font-bold text-xl text-gray-800 mb-2 md:mb-0">
                  Subcategorii in <span className="text-blue-600">{categorieExtinsa}</span>
                </h3>
                <button
                  onClick={function() { pornesteCautarea(categorieExtinsa); }}
                  className="text-sm font-bold text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1"
                >
                  Vezi toate anunturile din aceasta categorie
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-4 gap-x-6">
                {categorieGasita.subcategorii.map(function(sub) {
                  return (
                    <button
                      key={sub}
                      onClick={function() { pornesteCautarea(categorieExtinsa, sub); }}
                      className="text-left text-sm font-medium text-gray-700 hover:text-blue-600 hover:underline flex items-start gap-2 py-1"
                    >
                      <svg className="w-4 h-4 text-gray-400 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                      {sub}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>

      <main className="max-w-7xl mx-auto p-4 mt-16 mb-24">
        <div className="flex justify-between items-end mb-8">
          <div>
            <h3 className="text-3xl font-black text-gray-900 tracking-tight">Anunturi adaugate recent</h3>
            <p className="text-gray-500 mt-2 font-medium">Cele mai noi oferte din comunitate</p>
          </div>
          <Link to="/cautare" className="hidden md:flex text-blue-600 font-bold hover:text-blue-800 items-center gap-1">
            Vezi tot
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {incarca ? (
            skeletonItems.map(function(i) {
              return (
                <div key={i} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
                  <div className="aspect-[4/3] bg-gray-200"></div>
                  <div className="p-5">
                    <div className="h-4 bg-gray-200 rounded-full mb-3 w-3/4"></div>
                    <div className="h-4 bg-gray-200 rounded-full mb-6 w-1/2"></div>
                    <div className="h-8 bg-gray-200 rounded-xl w-1/2"></div>
                  </div>
                </div>
              );
            })
          ) : anunturi.length === 0 ? (
            <div className="col-span-4 text-center py-24 bg-white rounded-3xl border border-gray-100 shadow-sm">
              <p className="text-gray-500 text-xl font-medium">Platforma noastra se incalzeste. Nu exista anunturi momentan.</p>
            </div>
          ) : (
            anunturi.slice(0, 12).map(function(anunt) {
              const esteFavorit = listaFavorite.includes(anunt._id);
              return (
                <Link to={'/anunt/' + anunt._id} key={anunt._id} className="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full relative border border-gray-100">
                  <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
                    {anunt.imagine ? (
                      <img src={anunt.imagine} alt={anunt.titlu} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
                    ) : (
                      <div className="w-full h-full flex flex-col items-center justify-center text-gray-400 bg-gray-50">
                        <span className="text-sm font-medium">Fara imagine</span>
                      </div>
                    )}
                    <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-lg text-xs font-black text-gray-800 shadow-sm uppercase tracking-wider">
                      {anunt.categorie}
                    </div>
                    <button
                      onClick={function(e) { toggleFavorit(e, anunt._id); }}
                      className={'absolute top-3 right-3 p-2.5 bg-white/95 backdrop-blur-sm rounded-full shadow-sm transition-colors z-10 ' + (esteFavorit ? 'text-rose-500' : 'text-gray-400 hover:text-rose-500')}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill={esteFavorit ? 'currentColor' : 'none'} viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </button>
                  </div>
                  <div className="p-5 flex flex-col flex-grow">
                    <h4 className="font-bold text-gray-900 leading-snug line-clamp-2 mb-4 group-hover:text-blue-600 transition-colors">
                      {anunt.titlu}
                    </h4>
                    <div className="mt-auto flex items-end justify-between">
                      <div className="bg-blue-50 px-3 py-1.5 rounded-lg">
                        <p className="text-xl font-black text-blue-700">{anunt.pret} <span className="text-sm font-bold">RON</span></p>
                      </div>
                      <p className="text-xs text-gray-500 font-medium">
                        {anunt.localitate}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Acasa;